import { ApiClient } from '@utils/apiClient';

export interface PendingLegalDocument {
  id: string;
  document_type: string;
  type_label: string;
  version: string;
  title: string;
  url: string;
}

interface PendingResponse {
  pending: PendingLegalDocument[];
}

const CONSENT_ENDPOINT = '/organizations/legal/consent/';

export const legalService = {
  /**
   * Returns the active legal documents (AGB / AVV) the current organization
   * has not yet accepted. Empty array means nothing is pending.
   */
  async getPendingDocuments(): Promise<PendingLegalDocument[]> {
    const response = await ApiClient.get(CONSENT_ENDPOINT);
    if (!response.ok) {
      // Fail open: do not block the user if the check itself fails.
      return [];
    }
    const data = (await response.json().catch(() => ({ pending: [] }))) as PendingResponse;
    return Array.isArray(data.pending) ? data.pending : [];
  },

  /**
   * Records acceptance of all currently active legal documents for the
   * current organization. Resolves to the number of documents accepted.
   */
  async acceptDocuments(): Promise<number> {
    const response = await ApiClient.post(CONSENT_ENDPOINT);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to record legal acceptance.');
    }
    const data = (await response.json().catch(() => ({ accepted: 0 }))) as {
      accepted?: number;
    };
    return data.accepted ?? 0;
  },
};
